module.exports = __webpack_public_path__ + "img/476a5dc1-0b21-4d4e-83b3-824812ac9ab9.724baa2c.png";